import * as THREE from "three";
import {aircraftConfig} from "../../config";
import Vue from "vue";

export class TextureSwitcher{

    constructor(panorama) {
        this.textureLoader = new THREE.TextureLoader();
        this.textureLoader.crossOrigin = '*'
        this.textures = {};
        this.panorama = panorama;
    }

    register(name, path){
        Vue.$log.debug('register texture', name, path)
        this.textures[name] = this.textureLoader.load( path );
    }

    registerFromConfig() {
        const preloadKeys = aircraftConfig.getConfig().preload
        if(preloadKeys){
            preloadKeys.forEach(key => {
                this.register(key, aircraftConfig.getAsset(key))
            })
        }
        return this;
    }

    changeTo(name){
        Vue.$log.debug('change texture to ' + name)
        if(!this.textures[name]){
            throw new Error('Texture not registered: ' + name + '. Registered ones: ' + Object.keys(this.textures).join(','))
        }
        this.panorama.updateTexture( this.textures[name] );
    }
}